import {
  Col,
  Divider,
  Form,
  InputNumber,
  Row,
  Select,
  SelectProps,
} from "antd";
import { useForm } from "antd/es/form/Form";
import React from "react";
import CTConfiguration from "../../Services/CTConfigurationService";
import { Utils } from "../../Utilities/Utils";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";

const AddTaxRates = ({ id, onDismiss, record, addedYears, isViewOnly = false }: any) => {
  // const { openNotification } = React.useContext(adminContext);
  const [form] = useForm();
  const [selYearOptions, setSelYearOptions] = React.useState<SelectProps["options"]>([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (addedYears?.length > 0) {
      const optn: SelectProps["options"] = [];
      let startYear = Math.min(...addedYears);
      let endYear = Math.max(...addedYears) + 10;
      for (let i = startYear; i <= endYear; i++) {
        console.log("years", addedYears);
        optn.push({
          value: i,
          label: i,
          disabled: addedYears?.includes(i) ? true : false,
        });
      }
      setSelYearOptions(optn);
    }
  }, [addedYears]);

  React.useEffect(() => {
    if (id !== undefined) {
      form.setFieldsValue({
        year: record?.year,
        mainRate: record?.mainRate,
        smallProfitRate: record?.smallProfitRate,
        specialRate: record?.specialRate,
        mrLowerLimit: record?.mrLowerLimit,
        mrUpperLimit: record?.mrUpperLimit,
        standardFractionUp: record?.standardFractionUp,
        standardFractionLow: record?.standardFractionLow,
        ringFanceRate: record?.ringFanceRate,
        ringFanceSmallProfitRate: record?.ringFanceSmallProfitRate,
        ringFanceFractionLow: record?.ringFanceFractionLow,
        ringFanceFractionUp: record?.ringFanceFractionUp,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return (
    <SAModal
      footer={isViewOnly ? null : undefined}
      open={true}
      confirmLoading={loading}
      okText={"Save"}
      cancelText={"Cancel"}
      onOk={() => {
        setLoading(true);
        //var record = form.getFieldsValue();
        form.validateFields().then(async (values: any) => {
          CTConfiguration.saveTaxrates(id !== undefined ? values?.year : 0, values).then((res) => {
            if (res.status) {
              onDismiss(true);
              setLoading(false);
            } else {
              setLoading(false);
            }
          });
        }).catch((err) => {
          // openNotification("error", 'Select a year');
          setLoading(false);
        })
      }}
      onCancel={() => onDismiss(false)}
      title={
        id !== undefined ? `Edit Tax Rates (${record?.year})` : "Add Tax Rates"
      }
      width={700}
    // width={1000}
    >
      <Form form={form} disabled={isViewOnly} requiredMark={true}>
        <Col
          span={24}
          className="card border-rounded-1 bg-secondary"
        >
          {/* Year */}
          <Row >
            <Col span={24}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Year"
                name="year"
                rules={[
                  {
                    required: true,
                    message: "Please select a year",
                  },
                ]}
              >
                <Select
                  className="select-height-28"
                  placeholder="Select year"
                  disabled={id ? true : false}
                  options={selYearOptions}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Rates */}
          <Divider
            orientation="left"
            orientationMargin="0"
            style={{ margin: "13px 0px 3px 0px" }}

          >
            <p style={{ fontWeight: 650 }}>Rates</p>
          </Divider>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Main rate"
                name="mainRate"
              >
                <InputNumber
                  controls={false}
                  placeholder="Main rate"
                  className="line-height-28"
                  prefix="%"
                  onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Small profit rate"
                name="smallProfitRate"
              >
                <InputNumber
                  controls={false}
                  placeholder="Small profit rate"
                  className="line-height-28"
                  prefix="%"
                  onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Special rate"
                name="specialRate"
              >
                <InputNumber
                  controls={false}
                  placeholder="Special rate"
                  className="line-height-28"
                  prefix="%"
                  onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Limits */}
          <Divider
            orientation="left"
            orientationMargin="0"
            //  style={{ margin: "8px 0px" }}
            style={{ margin: "13px 0px 3px 0px" }}
          >
            <p style={{ fontWeight: 650 }}>Limits</p>
          </Divider>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Marginal relief lower limit"
                name="mrLowerLimit"
              >
                <InputNumber
                  controls={false}
                  placeholder="Marginal relief lower limit"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Marginal relief upper limit"
                name="mrUpperLimit"
              >
                <InputNumber
                  controls={false}
                  placeholder="Marginal relief upper limit"
                  className="line-height-28"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Standard Fraction */}
          <Divider
            orientation="left"
            orientationMargin="0"
            style={{ margin: "13px 0px 3px 0px" }}
          >
            <p style={{ fontWeight: 650 }}>Standard Fraction</p>
          </Divider>
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Standard fraction up"
                name="standardFractionUp"
              >
                <InputNumber
                  controls={false}
                  placeholder="Standard fraction up"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Standard fraction low"
                name="standardFractionLow"
              >
                <InputNumber
                  controls={false}
                  placeholder="Standard fraction low"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Ring Fance */}
          <Divider
            orientation="left"
            orientationMargin="0"
            style={{ marginTop: "13px", marginBottom: "3px" }}
          >
            <p style={{ fontWeight: 650 }}>Ring Fance</p>
          </Divider>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Ring fance rate"
                name="ringFanceRate"
              >
                <InputNumber
                  controls={false}
                  placeholder="Ring fance rate"
                  prefix="%"
                  onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Ring fance small profit rate"
                name="ringFanceSmallProfitRate"
              >
                <InputNumber
                  controls={false}
                  placeholder="Ring fance small profit rate"
                  prefix="%"
                  onKeyPress={(e) => Utils.ValidatePercentageOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Ring fance fraction low"
                name="ringFanceFractionLow"
              >
                <InputNumber
                  controls={false}
                  placeholder="Ring fance fraction low"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                className="custom-form-item"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                label="Ring fance fraction up"
                name="ringFanceFractionUp"
              >
                <InputNumber
                  controls={false}
                  placeholder="Ring fance fraction up"
                  prefix="£"
                  onKeyPress={(e) => Utils.ValidateAmountOnly(e)}
                  style={{ width: "100%", height: 26 }}
                />
              </Form.Item>
            </Col>
          </Row>

        </Col>
      </Form>
    </SAModal>
  );
};

export default AddTaxRates;
